import { render, staticRenderFns } from "./NewBillAdd.vue?vue&type=template&id=3042fdb2"
import script from "./NewBillAdd.vue?vue&type=script&lang=js"
export * from "./NewBillAdd.vue?vue&type=script&lang=js"
import style0 from "./NewBillAdd.vue?vue&type=style&index=0&id=3042fdb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports